import React from 'react';
import s from './SkillsFeedbackTable.module.css';
import common from '../../styles/common-styles.module.css';
import ColorBlock from '../ColorBlock/ColorBlock';

const getScreenText = (value) => {
  if (value === 0) {
    return 'no feedback reviewed';
  }
  if (value < 0.5) {
    return 'less than 50% of feedback reviewed';
  }
  return 'more than 50% of feedback reviewed';
};

const getReviewedByStudentColumn = (item, value, maxValue) => {
  const rawValue = item[value];
  const rawMaxValue = item[maxValue];
  let colorBlockValue = -1;

  if (rawValue === -1) {
    return (
      <div>—
        <span className={common.screenReaderText}>no data</span>
      </div>
    );
  }
  if (rawMaxValue > 0) {
    colorBlockValue = (rawValue / rawMaxValue);
  }
  return colorBlockValue >= 0.5 ? (
    <div>
      <ColorBlock
        value={colorBlockValue}
        mediumRangeMinValue={0.01}
        highRangeMinValue={0.5}
        className={s.colorBlock}
      >
        {rawValue}
      </ColorBlock>
    </div>
  ) : (
    <div>
      <ColorBlock
        value={colorBlockValue}
        mediumRangeMinValue={0.01}
        highRangeMinValue={0.5}
        className={s.colorBlock}
        aria-label={`${getScreenText(colorBlockValue)}`}
      >
        {rawValue}
      </ColorBlock>
      <span className={common.screenReaderText}>
        {`${getScreenText(colorBlockValue)}`}
      </span>
    </div>
  );
};

export {
  getReviewedByStudentColumn,
};
